import { ImageExtension } from '@enums/images.enum'
import { VelvetSDK } from 'sdk'

export const useImgUrlTransform = (image: string, format: string, extension: ImageExtension = ImageExtension.WEBP) => {
  const config = VelvetSDK.Configuration.configuration
  const overrideFormat = config?.dynamicImages.overrides.format
  const overrideExtension = config?.dynamicImages.overrides.extension
  const enabledImgTransform = config?.dynamicImages.enabled

  if (image) {
    if (enabledImgTransform && overrideFormat && overrideExtension) {
      return image.replace(overrideFormat, format).replace(overrideExtension, extension)
    } else {
      return image
    }
  }
}
